import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './meeting-archives.types';

export const meetingArchiveSelectors = {
  ...generateResourceSelectors<types.IMeetingArchive>((state) => state.resource.meetingArchives),
};
